export const MAX_EXPORT_TASKS = 100;

// Относительный путь: и dev (vite proxy /api → poizon-api.com), и prod (nginx)
// одинаково роутят /api/product-storage в product-storage сервис.
export const PRODUCT_STORAGE_URL = "/api/product-storage";

export const WATERMARK_PREVIEW_IMAGE_URL =
  "https://s3.twcstorage.ru/poparce-public/export/watermark-preview.jpg";
